module.exports = __webpack_public_path__ + "img/upper_pockets_move_vertically.7acde65f.png";